export default {
  roles: {
    organizer: 'Organizer',
    chair: 'Program Chair',
  },
};
